/**
 * Buy actions — variant selection, add to cart, hang.
 *
 * "add to cart" goes straight to the Shopify AJAX Cart API so apps and
 * analytics see a normal cart. Checkout is never intercepted.
 *
 * "hang" puts the variant on the fitting rail (Phase 3 renders it). Items stay
 * on the rail after being added to the cart — it is a rail, not a basket.
 */

function initProductForm(scope = document) {
  const form = scope.querySelector('#product-form') || document.getElementById('product-form');
  if (!form || form.dataset.formReady) return;
  form.dataset.formReady = 'true';

  const dataEl = document.querySelector('[data-variant-data]');
  const variants = dataEl ? JSON.parse(dataEl.textContent) : [];

  const variantInput = form.querySelector('[data-variant-id]');
  const priceEl = document.querySelector('[data-price]');
  const addBtn = form.querySelector('[data-add-to-cart]');
  const addLabel = form.querySelector('[data-add-label]');
  const hangBtn = form.querySelector('[data-hang]');
  const status = form.querySelector('[data-buy-status]');

  const money = (cents) =>
    (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'GBP'
    });

  const say = (message) => {
    if (status) status.textContent = message || '';
  };

  /* ---- Variant selection ---------------------------------- */

  const selectedOptions = () =>
    [...form.querySelectorAll('input[type="radio"]:checked')]
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map((input) => input.value);

  function currentVariant() {
    const chosen = selectedOptions();
    if (!chosen.length) return variants[0];
    return variants.find((variant) =>
      chosen.every((value, i) => variant.options[i] === value)
    );
  }

  function syncVariant() {
    const variant = currentVariant();

    if (!variant) {
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = 'unavailable';
      return;
    }

    if (variantInput) variantInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    if (addBtn) addBtn.disabled = !variant.available;
    if (addLabel) addLabel.textContent = variant.available ? 'add to cart' : 'sold out';
    say('');
  }

  form.querySelectorAll('input[type="radio"]').forEach((input) => {
    input.addEventListener('change', syncVariant);
  });

  /* ---- Add to cart ---------------------------------------- */

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const variant = currentVariant();
    if (!variant || !variant.available) return;

    addBtn.disabled = true;
    say('adding…');

    try {
      const response = await fetch(window.Shopify?.routes?.root
        ? `${window.Shopify.routes.root}cart/add.js`
        : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'That could not be added.');
      }

      say('added to cart');
      document.dispatchEvent(new CustomEvent('ss:cartupdate'));
    } catch (error) {
      say(error.message);
    } finally {
      addBtn.disabled = !variant.available;
    }
  });

  /* ---- Hang ----------------------------------------------- */

  const RAIL_KEY = 'ss_rail';

  const readRail = () => {
    try {
      return JSON.parse(localStorage.getItem(RAIL_KEY)) || [];
    } catch (e) {
      return [];
    }
  };

  if (hangBtn) {
    hangBtn.addEventListener('click', () => {
      const variant = currentVariant();
      if (!variant) return;

      const item = {
        variantId: variant.id,
        handle: hangBtn.dataset.productHandle,
        title: hangBtn.dataset.productTitle,
        variantTitle: variant.title === 'Default Title' ? '' : variant.title,
        image: hangBtn.dataset.productImage || '',
        price: variant.price
      };

      // hang-rail.js owns persistence; this only reads, to word the feedback.
      const already = readRail().some((entry) => entry.variantId === item.variantId);
      say(already ? 'already hanging' : 'hung');

      // The rail listens for this, dedupes, and runs the fly-to-rail animation
      // from the button the visitor actually pressed.
      document.dispatchEvent(new CustomEvent('ss:hang', { detail: { item, origin: hangBtn } }));
    });
  }

  syncVariant();
}

initProductForm();

/* Section markup is replaced wholesale by the theme editor. */
document.addEventListener('shopify:section:load', (event) => initProductForm(event.target));
